import Alpine from 'alpinejs';
import { SearchBox } from './searchbox';
import { ContentWrapper } from './content_wrapper';
import { JumpToBottom } from './jump_to_bottom';
import { RecentSearches } from './recent_searches';
import { LoadingHandler } from './loading_handler';
import { SelectionHandler } from './selection_handler';
import { Tabs } from './tabs';
import { INITIAL_ACTIVE_TAB } from './config';
import { appStore } from '@/stores/app';
import { virtualKeyboardDetector } from '@/utils/virtual_keyboard_detector';

const globalData = appStore.getGlobalData();

const contentWrapper = new ContentWrapper(globalData.isMobile, virtualKeyboardDetector);
const jumpToBottom = new JumpToBottom();
const recentSearches = new RecentSearches();
const loadingHandler = new LoadingHandler();
const selectionHandler = new SelectionHandler();
const tabs = new Tabs(INITIAL_ACTIVE_TAB);

/**
 * TLDR: Cache safe renaming from "newSearchbox" to "searchbox". Remove when new component name is cached.
 *
 * Longer explanation:
 * Because of the old searchbox component removal we rename the new component's name from newSearchbox to searchbox.
 * Doing this in a single deploy would cause the searchbox to fail until the old version of the page HTML is cached.
 * After this is released and you see x-data="searchbox" in the page HTML, remove this function and use 'searchbox' as component name.
 */
const getComponentName = (): 'searchbox' | 'newSearchbox' => {
    const cachedSearchboxDivIsPresent = !!document.querySelector(`[x-data="newSearchbox"]`);

    if (cachedSearchboxDivIsPresent) {
        return 'newSearchbox';
    }

    return 'searchbox';
};

Alpine.data(
    getComponentName(),
    () =>
        new SearchBox(
            globalData.isMobile,
            globalData.hideExplicitContent,
            jumpToBottom,
            contentWrapper,
            recentSearches,
            loadingHandler,
            selectionHandler,
            tabs
        )
);
